import { FormLogin } from "../components";
import { LoginLayout } from "../layout/LoginLayout";

export const LoginPage = () => {

  return (
    <LoginLayout>
      <FormLogin />
    </LoginLayout>
  );
};
